function Side () {
  return (
    <section id="side">
      <div className="side">
        <a href="https://github.com/tigeryant" className="icon-link side-icon mb-4" target="_blank" rel="noreferrer"><i className="bi bi-github"></i></a>
        <a href="https://www.linkedin.com/in/john-davies-18639b223/" className="icon-link side-icon mb-4" target="_blank" rel="noreferrer"><i className="bi bi-linkedin"></i></a>
        <div className="line">
        </div>
      </div>
    </section>

  )
}

export default Side